import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { StatusBadge } from '@ikea-food-ux/ppsi';
import ProductHeader from '../ProductHeader';
import CenteredProductImage from '../ProductImage/CenteredProductImage';
import theme from '../ui/theme';
import useRoutes from '../../routes/useRoutes';
import useLabels from '../Internationalization/useLabels';
import DataContext from '../DataContext/DataContext';

const MotionLink = motion(Link);

const Card = styled(MotionLink)`
  width: ${theme.card.width};
  margin: 0 1rem 1rem 0;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.87);
  background-color: #fff;
  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.1);
`;


const ImageContainerStyle = styled.div`
  position: relative;
  margin: 0 auto 0.7rem auto;
  max-width: 240px;
`;

const ClaimHeightStyle = styled.div`
  padding-bottom: 99.95%;
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: ${theme.color.white};
  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

const BadgeContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
const DishLogoDiv =styled.div`
 position: absolute;
 top: 10px;
 left: 10px;
 z-index:1;
 > img {    
    height: 25px;   
  }`

const GridItem = React.forwardRef(({ ppsi }, ref) => {
 
  const { language } = useContext(DataContext);
  const routes = useRoutes();
  const [newLabel, updatedLabel] = useLabels('new', 'updated');
  const {
    id,
    mainImage,
    modifyDate,
    launchDate,
    info,
    isNew,
    isUpdated,
    ppsiTag,
    dishLabel
  } = ppsi;
  const updateBadge = 'update';
  const newBadge = 'new';

  return (
    <Card
      to={routes.ppsiRoute(id)}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: 'easeInOut', duration: 0.2 }}
      ref={ref}
    >
      <ImageContainerStyle>
        <ClaimHeightStyle>
          {dishLabel&&<DishLogoDiv>
            <img src={dishLabel&&dishLabel.dishLogo&&dishLabel.dishLogo.thumbnailUrl} alt=""/>
          </DishLogoDiv>}
          <CenteredProductImage
            images={mainImage}
            alt={info[language].presentationName}
            sizes="250px"
          />
        </ClaimHeightStyle>
        <BadgeContainer>
          <StatusBadge visible={ppsiTag==='new'} text={newLabel} showBadge ={newBadge}/>
          <StatusBadge visible={ppsiTag==='updated'} text={updatedLabel} showBadge = {updateBadge}/>
        </BadgeContainer>
      </ImageContainerStyle>
      <ProductHeader
        title={info[language].presentationName}
        showAsNew={modifyDate < launchDate}
      />
    </Card>
  );
});

export default GridItem;
